<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tipodivision">
    <fieldset id="agregar_tipodivision" class="">
        <div class="step_section">
            <div class="row" id="row">
                <form [formGroup]="form">
                    <div class="col-md-12" id="content">
                        <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="tp_dir_message"></span>
                        </div>
                        <div class="form-horizontal titulo">
                            <div class="form-group" align="left">
                                <div class="col-sm-2">
                                    <label for="tipoaprob">Tipo de division</label>
                                </div>
                                <div class="col-sm-10" class="inline" style="font-size: 13px">
                                    <div class="col-md-10">
                                        <mat-checkbox formControlName="tipo_division1" name="tipo_division1" value="SI" (change)="add_tipo_division()">SUBDIVISI&Oacute;N</mat-checkbox>
                                    </div>
                                    <div class="col-md-2"></div>
                                    <div class="col-md-10">
                                        <mat-checkbox formControlName="tipo_division2" name="tipo_division2" value="SI" (change)="add_tipo_division()">FUSI&Oacute;N</mat-checkbox>
                                    </div>
                                    <div class="col-md-2"></div>
                                    <div class="col-md-10">
                                        <mat-checkbox formControlName="tipo_division3" name="tipo_division3" value="SI" (change)="add_tipo_division()">URBANIZACI&Oacute;N</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </form>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>